import React from "react";
import styled from "@emotion/styled";
import { Box, SystemStyleObject } from "@chakra-ui/react";
import { chakra } from "@chakra-ui/react";
import { keyframes } from "@emotion/react";
import * as animationData from "@/assets/loading-user.json";
import Lottie from "lottie-react";

export interface ButtonProps {
  variant?: "filled" | "outlined" | "shadowed";
  disabled?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  children?: React.ReactNode;
  className?: string;
  sx?: SystemStyleObject; // 添加 sx 属性
  loading?: boolean;
}

// chakra 提供了一个 chakra 函数,它可以将任何组件转换为支持 Chakra UI 样式系统的组件
// 当使用 chakra() 包装一个组件时,它会注入 Chakra UI 的样式系统功能
// 这意味着该组件将能够接收 sx 属性,并且 sx 中定义的样式会覆盖组件的基础样式
// 这是因为 Chakra UI 的样式系统使用了 CSS-in-JS,并且遵循"后来居上"的原则
// sx 属性中的样式是在运行时动态注入的,所以会覆盖静态定义的基础样式
const BaseButton = chakra(styled.button<ButtonProps>`
  // 基础样式
  width: 335px;
  height: 70px;
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  // 变体样式
  ${(props) => {
    switch (props.variant) {
      case "filled":
        return `
          background: #D8762B;
          border: 1px solid #D8762B;
          color: #fff;
          
        
          
          &:active:not(:disabled) {
            background: #B35F22;
            border-color: #B35F22;
          }
        `;
      case "outlined":
        return `
          background: #fff;
          border: 1px solid #D8762B;
          color: #D8762B;
          
       
          
          &:active:not(:disabled) {
            background: #FFE4D1;
          }
        `;
      case "shadowed":
        return `
          background: #fff;
          color: #000;
          filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.08));
        `;
      default:
        return "";
    }
  }}
`);

// 添加旋转动画的keyframes定义
const spinAnimation = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const LogsButton: React.FC<ButtonProps> = ({
  variant = "filled",
  disabled = false,
  onClick,
  children,
  className,
  sx,
  loading,
}) => {
  // 添加状态管理
  const buttonRef = React.useRef<HTMLButtonElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    // 点击后强制失去焦点
    // 调用原来的onClick处理函数
    onClick?.(event);
    setTimeout(() => {
      buttonRef.current?.blur();
    }, 100);
  };

  return (
    <BaseButton
      variant={variant}
      disabled={disabled}
      onClick={handleClick}
      className={className}
      sx={sx}
    >
      {loading ? (
        <Lottie
          animationData={animationData}
          loop={true}
          style={{
            width: "40px",
            height: "40px",
          }}
        />
      ) : (
        children
      )}
    </BaseButton>
  );
};
